/**
 * @author       luis.orihuela@zumper.com (Luis Orihuela)
 * @copyright    Copyright (c) 2023, Zumper
 */

import type { AutocompleteApiResult } from '@zcode/bizos'
import { AUTOCOMPLETE_BUILDING, AUTOCOMPLETE_CITY } from '../constants'

export const getCommaSeparatedText = (string1?: string | null, string2?: string | null) => {
  return [string1, string2].filter(Boolean).join(', ')
}

export const getAutocompleteResultText = (result: AutocompleteApiResult) => {
  let primaryText: string
  let secondaryText: string | undefined
  const { address, name, city, state, type } = result
  const cityState = getCommaSeparatedText(city, state)
  if (type === AUTOCOMPLETE_CITY) {
    primaryText = cityState
  } else {
    primaryText = name
    secondaryText =
      type === AUTOCOMPLETE_BUILDING ? getCommaSeparatedText(address, cityState) : cityState
  }
  return { primaryText, secondaryText }
}
